<div class="stk-modal-overlay" *ngIf="product" (click)="close()">
  <div class="realloc-modal" (click)="$event.stopPropagation()">

    <div class="realloc-modal__head">
      <div class="realloc-modal__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#A14D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="8.5" x2="18" y2="8.5"></line><polyline points="15,5.5 18,8.5 15,11.5"></polyline><line x1="20" y1="15.5" x2="6" y2="15.5"></line><polyline points="9,12.5 6,15.5 9,18.5"></polyline></svg>
      </div>
      <div class="realloc-modal__titles">
        <h3>Készlet átruházás</h3>
        <div>{{ product?.name }} · {{ product?.sku }}</div>
      </div>
      <button type="button" class="realloc-modal__close" title="Bezárás" (click)="close()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line></svg>
      </button>
    </div>

    <div class="realloc-modal__chips">
      <span class="realloc-chip">Készleten összesen: {{ stock }} db</span>
      <span class="realloc-chip">Igény: {{ totalNeed }} db · {{ orders.length }} rendelés</span>
      <span class="realloc-chip" [ngClass]="free > 0 ? 'realloc-chip--yellow' : 'realloc-chip--green'">Szabad most: {{ free }} db</span>
    </div>
    <div class="realloc-modal__intro">A rendszer időrendben foglalta le a készletet. A − gombbal elveszed a darabot egy rendeléstől, a + gombbal átadod egy másiknak — mentés után a „Hiányzó készlet” jelölések frissülnek.</div>

    <div class="realloc-modal__list">
      <div class="realloc-empty" *ngIf="loading">Rendelések betöltése…</div>
      <div class="realloc-empty" *ngIf="!loading && !draft.length">Nincs aktív, csomagolásra váró rendelés ehhez a termékhez.</div>

      <div
        class="realloc-row"
        *ngFor="let order of draft; index as i"
        [class.realloc-row--changed]="changed(i)"
        [class.realloc-row--full]="order.alloc >= order.need"
      >
        <div class="realloc-row__info">
          <div class="realloc-row__title">
            <span class="realloc-row__name">{{ order.customer }}</span>
            <span class="realloc-row__id">{{ order.displayId }}</span>
            <span class="realloc-row__country">{{ order.country }}</span>
            <span class="realloc-row__auto" *ngIf="order.auto && order.alloc > 0" title="A rendszer időrend szerint ehhez a rendeléshez foglalta le az utolsó darabot">Automatikus foglalás</span>
          </div>
          <div class="realloc-row__dates">
            <span class="realloc-row__placed">Beérkezett: {{ order.placedLabel }}</span>
            <span class="realloc-deadline" [ngClass]="'realloc-deadline--' + deadlineTone(order.days)">{{ deadlineLabel(order.days) }}</span>
          </div>
        </div>
        <div class="realloc-row__controls">
          <button
            type="button"
            class="realloc-step"
            [disabled]="!canMinus(order)"
            title="Darab elvétele ettől a rendeléstől"
            (click)="minus(i)"
          >−</button>
          <div class="realloc-count"><span class="realloc-count__alloc">{{ order.alloc }}</span><span class="realloc-count__need"> / {{ order.need }} db</span></div>
          <button
            type="button"
            class="realloc-step"
            [disabled]="!canPlus(order)"
            title="Darab átadása ennek a rendelésnek"
            (click)="plus(i)"
          >+</button>
          <span class="realloc-status" [ngClass]="order.alloc >= order.need ? 'realloc-status--full' : 'realloc-status--missing'">
            {{ order.alloc >= order.need ? 'Lefoglalva' : 'Hiány' }}
          </span>
        </div>
      </div>
    </div>

    <div class="realloc-modal__footer">
      <div class="realloc-modal__summary">{{ summary }}</div>
      <button type="button" class="stk-btn stk-btn--ghost" (click)="close()">Mégse</button>
      <button
        type="button"
        class="realloc-save"
        [class.realloc-save--enabled]="hasChange"
        [disabled]="!hasChange"
        (click)="save()"
      >Átruházás mentése</button>
    </div>

  </div>
</div>
